import AuthTeams from "../auth/AuthTeams";

const authTeams = new AuthTeams();

export function getTeamsRequestContext(teamsContext) {
  const storedTenantId = authTeams.getTenantId() || "";
  const storedChannelId = authTeams.getChannelId() || "";
  const storedGroupId = authTeams.getGroupId() || "";
  const storedMembershipType =
    localStorage.getItem("channelMembershipType") || "";
  const storedOwnerGroupId = localStorage.getItem("ownerGroupId") || "";
  const storedTeamGroupId = localStorage.getItem("teamGroupId") || "";

  const tenantId = teamsContext?.user?.tenant?.id || storedTenantId;
  const channelId = teamsContext?.channel?.id || storedChannelId;
  const membershipType =
    teamsContext?.channel?.membershipType || storedMembershipType;
  const groupId =
    membershipType === "Private"
      ? teamsContext?.channel?.ownerGroupId ||
        storedOwnerGroupId ||
        storedGroupId
      : teamsContext?.team?.groupId || storedTeamGroupId || storedGroupId;

  return {
    tenantId,
    groupId,
    channelId,
  };
}
